export const validateOrganizationNumber = (resp: any) => ({
  type: 'VALIDATE_ORGANIZATION_NUMBER',
  payload: resp,
});

export default {
  validateOrganizationNumber,
};
